import './index.scss'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import Accordion from './routes/accordion'
import Alert from './routes/alert'
import BackLink from './routes/backlink'
import Breadcrumbs from './routes/breadcrumbs'
import Button from './routes/button'
import Card from './routes/card'
import Checkbox from './routes/checkbox'
import Combobox from './routes/combobox'
import Consent from './routes/consent'
import Datepicker from './routes/datepicker'
import FileUpload from './routes/fileupload'
import Footer from './routes/footer'
import Header from './routes/header'
import HeaderFull from './routes/header-full'
import HeaderService from './routes/header-service'
import Heading from './routes/heading'
import Icon from './routes/icon'
import Index from './routes/index'
import Link from './routes/link'
import LinkCard from './routes/linkcard'
import Loader from './routes/loader'
import Messagebox from './routes/messagebox'
import Modal from './routes/modal'
import Progressbar from './routes/progressbar'
import PktRadioButton from './routes/radiobutton'
import Root from './routes/root'
import SearchInput from './routes/searchinput'
import Select from './routes/select'
import Stepper from './routes/stepper'
import Switch from './routes/switch'
import Table from './routes/table'
import Tabs from './routes/tabs'
import Tag from './routes/tag'
import TemplateForm from './routes/template-form'
import Textarea from './routes/textarea'
import Textinput from './routes/textinput'
import { ThemeProvider } from './theme/ThemeContext'

const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    children: [
      { index: true, element: <Index /> },
      { path: '/accordion', element: <Accordion /> },
      { path: '/alert', element: <Alert /> },
      { path: '/backlink', element: <BackLink /> },
      { path: '/breadcrumbs', element: <Breadcrumbs /> },
      { path: '/button', element: <Button /> },
      { path: '/card', element: <Card /> },
      { path: '/checkbox', element: <Checkbox /> },
      { path: '/combobox', element: <Combobox /> },
      { path: '/consent', element: <Consent /> },
      { path: '/datepicker', element: <Datepicker /> },
      { path: '/fileupload', element: <FileUpload /> },
      { path: '/footer', element: <Footer /> },
      { path: '/header', element: <Header /> },
      { path: '/header-service', element: <HeaderService /> },
      { path: '/heading', element: <Heading /> },
      { path: '/header-full', element: <HeaderFull /> },
      { path: '/icon', element: <Icon /> },
      { path: '/loader', element: <Loader /> },
      { path: '/messagebox', element: <Messagebox /> },
      { path: '/modal', element: <Modal /> },
      { path: '/link', element: <Link /> },
      { path: '/linkcard', element: <LinkCard /> },
      { path: '/progressbar', element: <Progressbar /> },
      { path: '/radiobutton', element: <PktRadioButton /> },
      { path: '/searchinput', element: <SearchInput /> },
      { path: '/select', element: <Select /> },
      { path: '/stepper', element: <Stepper /> },
      { path: '/switch', element: <Switch /> },
      { path: '/table', element: <Table /> },
      { path: '/tabs', element: <Tabs /> },
      { path: '/tag', element: <Tag /> },
      { path: '/template-form', element: <TemplateForm /> },
      { path: '/textarea', element: <Textarea /> },
      { path: '/textinput', element: <Textinput /> },
    ],
  },
])

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  </StrictMode>,
)
